// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VLfL6","newExpiryDate":"styles_newExpiryDate__1BMXJ","footer":"styles_footer__1c4lF"};